import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { Stripe } from "@stripe/stripe-js";

interface StripePaymentResponse {
  success: boolean;
  clientSecret?: string;
  paymentIntentId?: string;
  message?: string;
  error?: string;
  requiresAction?: boolean;
}

interface StripePaymentMethodResponse {
  success: boolean;
  paymentMethodId?: string;
  error?: string;
}

@Injectable({
  providedIn: "root",
})
export class StripeService {
  stripePromise: Promise<Stripe>;
  constructor(private http: HttpClient) {}
  getStripe(): Promise<Stripe | null> {
    return this.stripePromise;
  }
  createPaymentIntent(
    amount: number,
    invoiceId: string,
    parentId: string
  ): Observable<StripePaymentResponse> {
    return this.http.post<StripePaymentResponse>(
      `${environment.apiUrl}/stripe/create-payment-intent`,
      { amount, invoiceId, parentId }
    );
  }

  confirmPayment(
    paymentIntentId: string,
    paymentMethodId?: string
  ): Observable<StripePaymentResponse> {
    return this.http.post<StripePaymentResponse>(
      `${environment.apiUrl}/stripe/confirm-payment`,
      { paymentIntentId, paymentMethodId }
    );
  }

  createPaymentMethod(cardData: any): Observable<StripePaymentMethodResponse> {
    return this.http.post<StripePaymentMethodResponse>(
      `${environment.apiUrl}/stripe/create-payment-method`,
      { cardData }
    );
  }
  notifyPaymentSuccess(
    paymentIntentId: string,
    amount: number,
    invoiceId: string,
    parentId: string
  ): Observable<any> {
    return this.http.post(`${environment.apiUrl}/stripe/payment-success`, {
      paymentIntentId,
      amount,
      invoiceId,
      parentId,
    });
  }
}
